import { useEffect } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import icon1 from "../../../asset/image/new/hla-b-15-1.svg";
import icon2 from "../../../asset/image/new/hla-b-15-2.svg";
import icon3 from "../../../asset/image/new/hla-b-15-3.svg";
import icon4 from "../../../asset/image/new/hla-b-15-4.svg";
import icon5 from "../../../asset/image/new/hla-b-15-5.svg";
import TestingSteps from "../../../asset/image/new/hla-b-58-group.png";

function HLA1502() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    { name: "เภสัชพันธุศาสตร์", url: "/information/pharmacogeneticTest" },
    { name: "HLA-B*15:02", url: "/information/pharmacogeneticTest/HLAB1502" },
  ];

  const Hla_15 = [
    {
      url: `${icon1}`,
      name: "HLA-B*15:02",
      title:
        "การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
    },
    {
      url: `${icon2}`,
      name: "ความเสี่ยงต่อยา",
      title:
        "Carbamazepine (กลุ่มยากันชัก) ซึ่งเป็นยาถูกนำมาใช้ในการักษา อาการปวดเส้นประสาทใบหน้า (trigeminal neuralgia) ซึ่งภายหลังพบว่า มีประสิทธิภาพในการรักษาอาการชักด้วย",
    },
    {
      url: `${icon3}`,
      name: "อาการผื่นแพ้ยา",
      title: "เกิดภาวะแพ้ยารุนแรง ผื่นแดงลุกลาม หายใจลำบาก ความดันโลหิตตํ่า SJS/TEN (Stevens-Johnson syndrome/Toxic Epidermal Necrolysis)",
    },
    {
      url: `${icon4}`,
      name: "อาการแพ้ยารุนแรง",
      title:
        "เกิดตุ่มพอง ผิวหนังหลุดลอก อาการแทรกซ้อน อาจรุนแรงถึงขั้นพิการ หรือเสียชีวิตได้",
    },
    {
      url: `${icon5}`,
      name: "การตรวจยีนแพ้ยา",
      title:
        "HLA-B*15:02 [HLA-B75 (HLA-b*15:02 /HLA-B*15:08 / HLA-B*15:11 / HLA-B*15:21/ HLA-B*15:31)]",
    },
  ];
  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-1 w-full gap-5 py-8 mt-6">
        {Hla_15.map((hla, index) => (
          <div
            key={index}
            className="sm:flex-col sm:items-center flex flex-row gap-4"
          >
            <div className="xl:max-h-36 overflow-hidden min-w-36 w-[15%] aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img className="object-scale-down h-full" src={hla.url} alt={`รูปประกอบ ${hla.name}`}/>
            </div>
            <div className="flex flex-col gap-1 w-[80%] py-2">
              <span className="text-xl font-bold">{hla.name}</span>
              <span>{hla.title}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xl font-bold py-4">
        ขั้นตอนการตรวจยีน HLA-B*15:02
      </div>
      <div className="sm:px-2 sm:py-0 w-full aspect-[5/2] px-10 py-5 rounded-xl border border-gray-400">
        <img className="object-contain w-full" src={TestingSteps} alt={`รูปขั้นตอนการตรวจยีน HLA-B*15:02`}/>
      </div>
    </div>
  );
}
export default HLA1502;
